import { createContext } from 'react';

const PaymentContext = createContext({
  onFinalizePayment: (
    data?: any,
    onSuccess?: (res: any) => void,
    onError?: (error: any) => void,
    onFinally?: () => void
  ) => {},
  onPriceToBook: (
    data?: any,
    onSuccess?: (res: any) => void,
    onError?: (error: any) => void,
    onFinally?: () => void
  ) => {},
});

export { PaymentContext };
